import { h } from 'preact'

interface Props {
  views: number
}

const TopicViewsCount = ({ views } : Props) => (
  <span class='topic__views-count'>
    <i class="thread-meta-item__icon icon--eye icon--auto-width" aria-hidden="true"></i>
    <span class="thread-meta-item__text">
        {views}
    </span>
  </span>
)

export default TopicViewsCount
